import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MailingPopupComponent } from '@common/popups/mailing-popup/mailing-popup.component';
import { MessageBoxComponent } from '@common/popups/message-box/message-box.component';
import { SelectorPopupComponent } from '@common/popups/selector-popup/selector-popup.component';
import { CoreModule } from '@core/core.module';
import { NgxLoadingModule } from 'ngx-loading';
import { CalendarComponent } from './calendar/calendar.component';
import { CardContainerComponent } from './card-container/card-container.component';
import { CardComponent } from './card/card.component';
import { CenterComponent } from './center/center.component';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { ConnectionErrorComponent } from './connection-error/connection-error.component';
import { DataTableComponent, DomChangeDirective } from './data-table/data-table.component';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { DateSelectorComponent } from './date-picker/date-selector/date-selector.component';
import { DateTimeComponent } from './date-time/date-time.component';
import { IconTextComponent } from './icon-text/icon-text.component';
import { ModalComponent } from './modal/modal.component';
import { NumberInputComponent } from "./number-input/number-input.component";
import { PanelComponent } from './panel/panel.component';
import { ScrollbarComponent } from './scrollbar/scrollbar.component';
import { SharableContentComponent } from './sharable-content/sharable-content.component';
import { SortableComponent } from './sortable/sortable.component';
import { TextFilterComponent } from './text-filter/text-filter.component';
import { EllipsisComponent } from './ellipsis/ellipsis.component';
import { PaginationComponent } from './pagination/pagination.component';
import { DirectivesModule } from '@common/directives/directives.module';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DateRangeSelectorComponent } from './date-range-picker/date-range-selector/date-range-selector.component';
import { UnitComponent } from './unit/unit.component';
import { NumberComponent } from './number/number.component';
import { CnyComponent } from './unit/cny/cny.component';
import { VndComponent } from './unit/vnd/vnd.component';
import { MComponent } from './unit/m/m.component';
import { VndPerCnyComponent } from './unit/vnd-per-cny/vnd-per-cny.component';
import { VndPerMComponent } from './unit/vnd-per-m/vnd-per-m.component';
import { CnyPerMComponent } from './unit/cny-per-m/cny-per-m.component';
import { GoodComponent } from './good/good.component';
import { ProductUnitComponent } from './unit/product-unit/product-unit.component';
import { CnyPerUnitComponent } from './unit/cny-per-unit/cny-per-unit.component';
import { VndPerUnitComponent } from './unit/vnd-per-unit/vnd-per-unit.component';
import { SymbolPerUnitComponent } from './unit/symbol-per-unit/symbol-per-unit.component';
import { KgComponent } from './unit/kg/kg.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    RouterModule,
    NgxLoadingModule,
    DirectivesModule
  ],

  declarations: [
    ScrollbarComponent,
    EllipsisComponent,    
    CardComponent,
    DataTableComponent,
    DomChangeDirective,
    NumberInputComponent,
    DatePickerComponent,    
    ModalComponent,
    CardContainerComponent,
    PanelComponent,
    TextFilterComponent,
    SortableComponent,
    CollapsibleComponent,
    CalendarComponent,
    IconTextComponent,
    CenterComponent,
    SharableContentComponent,

    MessageBoxComponent,
    MailingPopupComponent,
    SelectorPopupComponent,
    DateSelectorComponent,
    DateTimeComponent,
    ConnectionErrorComponent,    
    PaginationComponent,

    DateRangePickerComponent,
    DateRangeSelectorComponent,
    UnitComponent,
    NumberComponent,
    CnyComponent,
    VndComponent,
    MComponent,
    VndPerCnyComponent,
    VndPerMComponent,
    CnyPerMComponent,
    GoodComponent,
    ProductUnitComponent,
    CnyPerUnitComponent,
    VndPerUnitComponent,
    SymbolPerUnitComponent,
    KgComponent,
  ],

  exports: [
    PaginationComponent,
    ScrollbarComponent,
    EllipsisComponent,
    CardComponent,
    DataTableComponent,
    NumberInputComponent,
    DatePickerComponent,
    ModalComponent,
    CardContainerComponent,
    PanelComponent,
    TextFilterComponent,
    SortableComponent,
    CollapsibleComponent,
    CalendarComponent,
    IconTextComponent,
    CenterComponent,
    SharableContentComponent,

    MessageBoxComponent,
    MailingPopupComponent,
    SelectorPopupComponent,
    DateSelectorComponent,
    DateTimeComponent,    
    ConnectionErrorComponent,

    DateRangePickerComponent,
    DateRangeSelectorComponent,
    UnitComponent,
    NumberComponent,
    CnyComponent,
    VndComponent,
    MComponent,
    VndPerCnyComponent,
    VndPerMComponent,
    CnyPerMComponent,
    GoodComponent,
    ProductUnitComponent,
    CnyPerUnitComponent,
    VndPerUnitComponent,
    SymbolPerUnitComponent,
    KgComponent

  ],
  entryComponents: [
    MessageBoxComponent,
    MailingPopupComponent,

    SelectorPopupComponent,
    DateSelectorComponent,
    DateRangeSelectorComponent,
  ]
})

export class UIModule {
}
